import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-50 mt-24">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center font-heading font-bold text-lg">
                料
              </span>
              <span className="font-heading font-bold text-xl">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-100/85">
              {siteInfo.slogan}。聚合热门爆料与现场记录，整理成清晰的分类与专题，随时翻看阅读。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <Link to="/" className="cursor-pointer hover:text-accent-300">内容导航</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-100/85">
              <li><Link to="/" className="cursor-pointer hover:text-accent-300">首页内容流</Link></li>
              <li><Link to="/about" className="cursor-pointer hover:text-accent-300">关于我们</Link></li>
              <li><Link to="/contact" className="cursor-pointer hover:text-accent-300">联系我们</Link></li>
              <li><Link to="/about#principles" className="cursor-pointer hover:text-accent-300">内容原则</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <Link to="/" className="cursor-pointer hover:text-accent-300">热门分类</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-100/85">
              {categories.slice(0, 5).map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="cursor-pointer hover:text-accent-300">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">
              <Link to="/contact" className="cursor-pointer hover:text-accent-300">联系方式</Link>
            </h4>
            <ul className="space-y-3 text-sm text-secondary-100/85">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-400">
                  <i className="ri-mail-line text-base" />
                </span>
                {siteInfo.email}
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-accent-400">
                  <i className="ri-time-line text-base" />
                </span>
                {siteInfo.workTime}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-200/70">
          <p>© {new Date().getFullYear()} {siteInfo.name} · 内容聚合与整理</p>
          <p>本站内容为话题记录与整理，不代表任何第三方立场</p>
        </div>
      </div>
    </footer>
  );
}